import { cva } from 'class-variance-authority'

export const styles = cva(
  `
    flex
    gap-6
    relative
    flex-grow
    px-10
  `,
  {
    variants: {
      variant: {
        default: 'flex-row-reverse',
        stack: 'flex-col relative',
        announcement: 'flex-row',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const bodyStyles = cva(
  `
    flex
    flex-col
    items-start
    gap-4
    flex-grow
  `
)

export const imgBgStyles = cva(
  `
    flex
    justify-center
    border-none
    rounded-2xl
    p-6
    flex-grow
  `
)
